import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import themeable from 'zignal-landscape/lib/themeable';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';

const CancelModal = ({
  styles,
  isOpen = false,
  title = 'Your changes will not be saved',
  confirmStyle = 'alert',
  size = 'small',
  boldText = 'Are you sure you want to cancel?',
  text = 'By clicking "cancel", your changes will not be saved and you will exit the wizard. Do you want to continue?',
  confirmText = 'Continue',
  onConfirm = noop,
  onCancel = noop
}) => {

  return (
    <ConfirmationModal
      isOpen={isOpen}
      title={title}
      confirmStyle={confirmStyle}
      confirmText={confirmText}
      size={size}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <h5 className={styles.boldText}>{boldText}</h5>
      <div>{text}</div>
    </ConfirmationModal>
  );
};

CancelModal.propTypes = {
  styles: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  confirmStyle: PropTypes.string,
  size: PropTypes.string,
  boldText: PropTypes.string,
  text: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
};

export default themeable(CancelModal);
